<script setup lang="ts">
defineOptions({
	name: 'IconProtection',
})

interface Props {
	class?: string
	classIcon?: string
}

const props = withDefaults(defineProps<Props>(), {
	class: 'text-neutral-50',
	classIcon: 'w-8 h-8',
})
</script>

<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		:class="[props.class, props.classIcon]"
		viewBox="0 0 42 43"
		fill="none"
	>
		<path
			d="M23.6716 19.7598V17.4008C23.6716 15.9255 22.4746 14.7285 20.9994 14.7285V14.7285C19.5241 14.7285 18.3271 15.9255 18.3271 17.4008V19.7598"
			stroke="currentColor"
			stroke-width="2.14286"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M24.0625 19.7612H17.9375C16.9715 19.7612 16.1875 20.5452 16.1875 21.5112V25.2282C16.1875 26.1942 16.9715 26.9782 17.9375 26.9782H24.0625C25.0285 26.9782 25.8125 26.1942 25.8125 25.2282V21.5112C25.8125 20.5452 25.0285 19.7612 24.0625 19.7612Z"
			stroke="currentColor"
			stroke-width="2.14286"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M35.001 19.9641C35.001 27.6081 29.4762 34.7726 21.911 36.9146C21.3195 37.0826 20.6825 37.0826 20.091 36.9146C12.5257 34.7743 7.00098 27.6081 7.00098 19.9641V12.9151C7.00098 11.4941 7.86023 10.2131 9.17623 9.67583L17.6882 6.19333C19.8127 5.32358 22.1927 5.32358 24.3155 6.19333L32.8275 9.67583C34.1417 10.2131 35.001 11.4941 35.001 12.9151V19.9641Z"
			stroke="currentColor"
			stroke-width="2.14286"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
